import { useState, useEffect } from 'react';
import { FormControl, Grid, makeStyles, InputLabel, Select, MenuItem } from '@material-ui/core'
import { roles } from '../../../../constants/roles';
import useToken from '../../../../hooks/useToken';
import { options } from './constant';
import { homeStrings } from '../../../../components/StringBundle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: 0,
    height: '100%',
    width: '100%',
    marginTop: theme.spacing(1),
  },
  filterRow: {
    flexShrink: 0,
    paddingBottom: theme.spacing(1),
  },
  formControl: {
    margin: 0,
    minWidth: 240,
    maxWidth: 320,
  },
  iframeWrap: {
    flex: '1 1 auto',
    minHeight: 0,
    position: 'relative',
    width: '100%',
  },
  iframeFull: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 'none',
    display: 'block',
  },
  comingSoon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    color: '#888',
  },
}));

const Home = () => {
  const classes = useStyles();
  const { getCurrentUserDetails } = useToken();
  const currentUserDetails = getCurrentUserDetails();
  const currentUserRole = currentUserDetails?.role;

  const [filteredOptions, setFilteredOptions] = useState([]);
  const [filter, setFilter] = useState(options.allOptions[0].id);
  const [activeurl, setActiveurl] = useState(options.allOptions[0].url);

  useEffect(() => {
    let optionsToShow = []; // Default to all options
    if (
      currentUserRole === roles.managerPurchaseGC ||
      currentUserRole === roles.purchaseExecutiveGC ||
      currentUserRole === roles.purchaseExecutiveGCview ||
      currentUserRole === roles.GeneralManagerPurchase
    ) {
      // Only for Green Coffee Dashboard, Inventory Status Dashboard,
      //  GC Allocation Dashboard, Receipts & Shipment Arrivals,
      // GC Receipts Dashboard, GC Pending Dashboard, GC Logistics Dashboard,
      //coast analysis Report, purchase report (top 15 items)
      optionsToShow = [
        options.allOptions[11],
        options.allOptions[0], //Green Coffee Dashboard
        options.allOptions[5],
        options.allOptions[6],
        options.allOptions[7],
        options.allOptions[8],
        options.allOptions[10],
        options.allOptions[12], //inventory available qty
        options.allOptions[14], // scm dashboard
        options.allOptions[15], // Inventory Summary Report
        options.allOptions[16], // Order Dispatch Status Tracker
        options.allOptions[17], // Order Schedule Quantity Report
        options.allOptions[19], // GC Consumption Dashboard
        options.allOptions[21], // Logistic Payment and Details Report
        options.allOptions[22], // Quote Vs Allocate Vs Consumed Price Dashboard
        options.allOptions[23], // GC Finance Budget Report
        options.allOptions[24], // GC Silo Dispensing Work Order Report
        options.allOptions[25], // Quote Status Tracker
      ];
    } else if ([roles.managerfinance].includes(currentUserRole)){
      optionsToShow = [
        options.allOptions[0], //Green Coffee Dashboard
      ];
    } else if ([
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentManager,
      roles.BDDomestic,
      roles.BusinessDevelopmentExecutive].includes(currentUserRole)) {
      optionsToShow = [
        options.allOptions[2],
        options.allOptions[3],
        options.allOptions[12], //inventory available qty
        options.allOptions[13], // Sales order Dashboard
        options.allOptions[14], // scm dashboard
        options.allOptions[15], // Inventory Summary Report
        options.allOptions[16], // Order Dispatch Status Tracker
        options.allOptions[17], // Order Schedule Quantity Report
        options.allOptions[19], // GC Consumption Dashboard
        options.allOptions[21], // Logistic Payment and Details Report
        options.allOptions[22], // Quote Vs Allocate Vs Consumed Price Dashboard
        options.allOptions[23], // GC Finance Budget Report
      ];
    } else if (currentUserRole === roles.managerCommerical) {
      optionsToShow = [
        options.allOptions[2],
        options.allOptions[4], // Capacity Calendar Dashboard
        options.allOptions[12], //inventory available qty
        options.allOptions[13], // Sales order Dashboard
        options.allOptions[14], // scm dashboard
        options.allOptions[15], // Inventory Summary Report
        options.allOptions[16], // Order Dispatch Status Tracker
        options.allOptions[17], // Order Schedule Quantity Report
        options.allOptions[18], // Export Logistics Dashboard
        options.allOptions[19], // GC Consumption Dashboard
        options.allOptions[21], // Logistic Payment and Details Report
        options.allOptions[22], // Quote Vs Allocate Vs Consumed Price Dashboard
        options.allOptions[23], // GC Finance Budget Report
        options.allOptions[25], // Quote Status Tracker
      ];
    } else if(currentUserRole === roles.commercialExecutive) {
      optionsToShow = [
        options.allOptions[2],
        options.allOptions[4], // Capacity Calendar Dashboard
        options.allOptions[12], //inventory available qty
        options.allOptions[13], // Sales order Dashboard
        options.allOptions[14], // scm dashboard
        options.allOptions[15], // Inventory Summary Report
        options.allOptions[16], // Order Dispatch Status Tracker
        options.allOptions[25], // Quote Status Tracker
      ];
    } else if (currentUserRole === roles.commercialHod) {
      optionsToShow = [
        options.allOptions[2],
        options.allOptions[4], // Capacity Calendar Dashboard
        options.allOptions[12], //inventory available qty
        options.allOptions[13], // Sales order Dashboard
        options.allOptions[15], // Inventory Summary Report
         options.allOptions[16], // Order Dispatch Status Tracker
         options.allOptions[18], // Export Logistics Dashboard
        options.allOptions[25], // Quote Status Tracker
      ];
    } else if (currentUserRole === roles.commercialAssociative) {
      optionsToShow = [
        options.allOptions[13], // Sales Order Dashboard
        options.allOptions[14], // scm dashboard
        options.allOptions[16], // Order Dispatch Status Tracker
      ];
    } else if (
      [roles.ProductionManager,
      roles.productionAssistant,
      roles.RDManagerBD].includes(currentUserRole)
    ) {
      optionsToShow = [
        options.allOptions[4],  // Only Capacity Calendar Dashboard
        options.allOptions[14], // scm dashboard
      ];
      if (
        currentUserRole === roles.ProductionManager ||
        currentUserRole === roles.productionAssistant
      ) {
        optionsToShow.push(options.allOptions[24]); // GC Silo Dispensing Work Order Report
      }
    } else if (
      [
        roles.productionplanning,
        roles.rdManager,
        roles.rdAssociate,
      ].includes(currentUserRole)
    ) {
      optionsToShow = [
        options.allOptions[4], // Only Capacity Calendar Dashboard
        options.allOptions[14], // scm dashboard  
        options.allOptions[16], // Order Dispatch Status Tracker
      ];
      if (currentUserRole === roles.productionplanning) {
        optionsToShow.push(options.allOptions[20]); // Packing Material Receipt Dashboard
        optionsToShow.push(options.allOptions[25]); // Quote Status Tracker
      }
    } else if (
      currentUserRole === roles.executiveLeadership ||
      currentUserRole === roles.readOnly ||
      currentUserRole === roles.Auditor
    ){
      optionsToShow = [
        options.allOptions[0], //Green Coffee Dashboard
        options.allOptions[2],
        options.allOptions[3],
        options.allOptions[4],
        options.allOptions[5],
        options.allOptions[6],
        options.allOptions[7],
        options.allOptions[8],
        options.allOptions[9],
        options.allOptions[10],
        options.allOptions[11],
        options.allOptions[12], //inventory available qty
        options.allOptions[13], //Sales Order Dashboard
        options.allOptions[14], // scm dashboard
        options.allOptions[15], // Inventory Summary Report
        options.allOptions[16], // Order Dispatch Status Tracker
        options.allOptions[17], // Order Schedule Quantity Report
        options.allOptions[20], // Packing Material Receipt Dashboard
        options.allOptions[25], // Quote Status Tracker
      ];
      // Export Logistics Dashboard is restricted to Executive Leadership and
      // Auditor only (not Read Only), so it is added separately here.
      if (
        currentUserRole === roles.executiveLeadership ||
        currentUserRole === roles.Auditor
      ) {
        optionsToShow.push(options.allOptions[18]); // Export Logistics Dashboard
        optionsToShow.push(options.allOptions[19]); // GC Consumption Dashboard
        optionsToShow.push(options.allOptions[21]); // Logistic Payment and Details Report
        optionsToShow.push(options.allOptions[22]); // Quote Vs Allocate Vs Consumed Price Dashboard
        optionsToShow.push(options.allOptions[23]); // GC Finance Budget Report
        optionsToShow.push(options.allOptions[24]); // GC Silo Dispensing Work Order Report
      }
    } else if (currentUserRole === roles.ceo ||
      currentUserRole === roles.factorymanager
    ) {
      optionsToShow = [
        options.allOptions[0], //Green Coffee Dashboard
        options.allOptions[2],
        options.allOptions[3],
        options.allOptions[4],
        options.allOptions[5],
        options.allOptions[6],
        options.allOptions[7],
        options.allOptions[8],
        options.allOptions[9],
        options.allOptions[10],
        options.allOptions[11],
        options.allOptions[12], //inventory available qty
        options.allOptions[13],// Sales Order Dashboard
        options.allOptions[14], // scm dashboard
        options.allOptions[15], // Inventory Summary Report
        options.allOptions[16], // Order Dispatch Status Tracker
        options.allOptions[17], // Order Schedule Quantity Report
        options.allOptions[19], // GC Consumption Dashboard
        options.allOptions[20], // Packing Material Receipt Dashboard
        options.allOptions[21], // Logistic Payment and Details Report
        options.allOptions[22], // Quote Vs Allocate Vs Consumed Price Dashboard
        options.allOptions[23], // GC Finance Budget Report
        options.allOptions[24], // GC Silo Dispensing Work Order Report
        options.allOptions[25], // Quote Status Tracker
      ];
      // Export Logistics Dashboard is restricted to CEO only (not Factory
      // Manager), so it is added separately here.
      if (currentUserRole === roles.ceo) {
        optionsToShow.push(options.allOptions[18]); // Export Logistics Dashboard
      }
    } else if (currentUserRole === roles.Chairman) {
      optionsToShow = [
        options.allOptions[10],
        options.allOptions[14], // scm dashboard
        options.allOptions[16], // Order Dispatch Status Tracker
        options.allOptions[18], // Export Logistics Dashboard
      ];
    } else if (currentUserRole === roles.GmProjects) {
      optionsToShow = [
        options.allOptions[14], // scm dashboard
        options.allOptions[16], // Order Dispatch Status Tracker
        options.allOptions[20], // Packing Material Receipt Dashboard
      ];
    } else if (currentUserRole === roles.managerGCStores) {
      optionsToShow = [
        options.allOptions[14], // scm dashboard
        options.allOptions[16], // Order Dispatch Status Tracker
        options.allOptions[24], // GC Silo Dispensing Work Order Report
      ];
    } else if(currentUserRole === roles.gcStoresExecutive){
      optionsToShow = [
        options.allOptions[14], // scm dashboard
        options.allOptions[16], // Order Dispatch Status Tracker
        options.allOptions[24], // GC Silo Dispensing Work Order Report
      ];
    } else if (
      [roles.qcManager,
      roles.qcHead,
      roles.managerfinance,
      roles.GMPacking,
      roles.AnalystQA,
      roles.managerPurchasePackaging,
      roles.factoryPackingManager,
      roles.accountsManager
      ].includes(currentUserRole)
    ) {
      optionsToShow = [
        options.allOptions[16], // Order Dispatch Status Tracker
      ];
      if (
        [
          roles.GMPacking,
          roles.managerPurchasePackaging,
          roles.factoryPackingManager,
        ].includes(currentUserRole)
      ) {
        optionsToShow.push(options.allOptions[20]); // Packing Material Receipt Dashboard
      }
    } else if ([roles.managerPackagingDevelopment].includes(currentUserRole)) {
      optionsToShow = [
        options.allOptions[20], // Packing Material Receipt Dashboard
      ];
    } else if (currentUserRole === roles.viewOnly) {
      optionsToShow = [
        options.allOptions[20], // Packing Material Receipt Dashboard
      ];
    } else if (
      [
        roles.admin,
        roles.managingDirector,
      ].includes(currentUserRole)
    ) {
      optionsToShow = options.allOptions.filter((_, index) => index !== 1);
    }
    // Drop disabled (null) / missing entries so the dropdown never gets undefined items
    optionsToShow = optionsToShow.filter(Boolean);
    const initialOption = optionsToShow[0];
    setFilter(initialOption?.id || '');
    setActiveurl(initialOption?.url || '');
    setFilteredOptions(optionsToShow);

  }, [currentUserRole]);

  // Function to handle dropdown change
  function changeFilter(e) {
    const selectedId = e.target.value;
    setFilter(selectedId);
    const selectedOption = filteredOptions.find(opt => opt.id === selectedId);
    setActiveurl(selectedOption?.url || '');
  }


  return (
    <div className={classes.root}>
      {/* Filter row: compact dropdown, left-aligned */}
      <div className={classes.filterRow}>
        <FormControl variant="outlined" className={classes.formControl} size="small">
          <InputLabel id="report">{homeStrings.reports}</InputLabel>
          <Select
            labelId="report"
            value={filter}
            onChange={changeFilter}
            label={homeStrings.reports}
            id="reports-select"
            MenuProps={{
              anchorOrigin: { vertical: "bottom", horizontal: "left" },
              transformOrigin: { vertical: "top", horizontal: "left" },
              getContentAnchorEl: null
            }}
          >
            {filteredOptions.map((item, index) => (
              <MenuItem key={index} value={item.id}>{item.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* Dashboard iframe — fills all remaining height */}
      <div className={classes.iframeWrap}>
        {activeurl !== 'coming' ? (
          <iframe
            title="quicksight-dashboard"
            className={classes.iframeFull}
            src={activeurl}
          />
        ) : (
          <div className={classes.comingSoon}>
            <h2>{homeStrings.comingSoon}</h2>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
